import { Box, BoxProps, styled } from "@mui/material";

export const Divider = styled(Box)<BoxProps>(({ theme }) => ({
    height: '2px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    background: theme.palette.grey[100],
    borderRadius: '1px',
}));
